import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import {
	hamburgerButton,
	menuPrimary,
	overlay,
	menuParentItems,
} from './elements.js'
import { collapseSection, expandSection } from './lib.js'

/**
 * Toggle main hamburger menu
 *
 * @author     Mario Hoyos
 * @version    1.0.0
 * @since      2022.1
 */
export function toggleMenu(e) {
	const expanded =
		hamburgerButton.getAttribute('aria-expanded') === 'true' || false
	const menuState = menuPrimary.getAttribute('data-visible') === 'true' || false

	if (
		e.currentTarget === hamburgerButton ||
		((e.currentTarget === overlay || e.keyCode === 27) && expanded)
	) {
		menuPrimary.setAttribute('data-visible', !menuState)
		overlay.setAttribute('data-visible', !menuState)
		hamburgerButton.setAttribute('aria-expanded', !expanded)

		if (expanded) {
			enableBodyScroll(menuPrimary)
		} else {
			disableBodyScroll(menuPrimary)
		}
	}
}

/**
 * Collapse all menus/submenus from primary navigation
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 * @since       2020.0
 * @param       int transitionTiming
 */
function collapseAllPrimaryMenus(transitionTiming) {
	menuParentItems.forEach((item) => {
		setTimeout(() => {
			item.setAttribute('aria-expanded', false)
		}, transitionTiming)
		collapseSection(item.nextElementSibling)
	})
}

/**
 * Move active focus to closest top level parent
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 * @since       2020.0
 * @param       int transitionTiming
 */
function moveFocusToParentMenuItem() {
	if (document.activeElement.closest('.c-menu__item--top-level')) {
		document.activeElement
			.closest('.c-menu__item--top-level')
			.querySelector('a')
			.focus()
	}
}

/**
 * Handle main menu clicks to show submenus
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 * @since       2020.0
 */
export function handleMenuClick(e) {
	const isOutside = !e.target.closest('#js-menu-primary')
	const transitionTiming = 150
	if (!e.keyCode) {
		if (isOutside) {
			collapseAllPrimaryMenus(transitionTiming)
		} else if (e.target.id === 'js-search-toggle') {
			collapseAllPrimaryMenus(transitionTiming)
		} else if (e.target.hasAttribute('aria-expanded')) {
			e.preventDefault()
			const menuItem = e.target.closest('[aria-expanded]')
			const isExpanded =
				menuItem.getAttribute('aria-expanded') === 'true' || false
			const subMenu = menuItem.nextElementSibling
			const closedItem = false

			if (isExpanded) {
				if (menuItem.parentNode.parentNode.classList.contains('sub-menu')) {
					menuItem.setAttribute('aria-expanded', !isExpanded)
					collapseSection(subMenu)
				} else {
					collapseAllPrimaryMenus(transitionTiming)
				}
			} else {
				menuParentItems.forEach((item) => {
					if (
						item !== menuItem &&
						item.getAttribute('aria-expanded') === 'true'
					) {
						setTimeout(() => {
							item.setAttribute('aria-expanded', false)
						}, transitionTiming)
						collapseSection(item.nextElementSibling)
						item.nextElementSibling.setAttribute('data-collapsed', 'true')
					}
				})
				menuItem.setAttribute('aria-expanded', !isExpanded)
				expandSection(subMenu, closedItem)
				subMenu.setAttribute('data-collapsed', 'false')
			}
		}
	} else if (e.keyCode === 27) {
		collapseAllPrimaryMenus(transitionTiming)
		moveFocusToParentMenuItem()
	}
}
